(async () => {

  if (!customElements.get('media-youtube')) {

    let counter = 0;

    class MediaYoutube extends HTMLElement {
      constructor() {
        super();

        // Youtube
        this.player = null;
        this.id = this.dataset.id;

        // listen for custom youtube play button
        this.querySelectorAll('[data-play-youtube]').forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault;
            this.playYoutube();
          });
        });
      }

      /*
      * Load and play Youtube
      */
      playYoutube() {
        // If no youtube slide
        if (!this.querySelector('[data-youtube-video]') || !this.id) {
          return false;
        }

        this.classList.remove('loading-api')
        this.classList.remove('loading-iframe');

        // If no youtube api, load api
        if (!document.querySelector('#yt-iframe-api')) {
          this.classList.add('loading-api');
          let tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          tag.id = 'yt-iframe-api'
          let firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          return false;
        }

        // If no youtube iframe, add iframe
        if (this.player == null) {
          counter++;
          this.classList.add('loading-iframe');
          this.querySelector('[data-youtube-video]').innerHTML = `<div id="player-${counter}"></div>`;
          this.player = new YT.Player(`player-${counter}`, {
            videoId: this.id,
            events: {
              'onReady': onPlayerReady,
            }
          });
          return false;
        }

        // Else play video
        this.player.playVideo();
        this.classList.add('playing');
        this.querySelector('[data-youtube-video]')?.classList.add('is-active');
        this.querySelector('[data-youtube-poster]')?.classList.add('is-inactive');
      }

      /*
      * Stop youtube
      */
      stopYoutube() {
        if (this.player == null) {
          return false;
        }
        this.classList.remove('playing');
        this.querySelector('[data-youtube-video]')?.classList.remove('is-active');
        this.querySelector('[data-youtube-poster]')?.classList.remove('is-inactive');
        setTimeout(() => {
          this.player.stopVideo();
        }, 500);
      }

    }

    window.MediaYoutube = MediaYoutube;

    customElements.define('media-youtube', MediaYoutube);

  }

})();

function onYouTubeIframeAPIReady() {
  document.querySelector('media-youtube.loading-api').playYoutube();
}
function onPlayerReady(event) {
  document.querySelector('media-youtube.loading-iframe').playYoutube();
}
